import { TFunction } from '@lyearn/i18n';
import { LargeFeedback, MeetingOutline, MessageSquare2Outline } from '@lyearn/icons';
import UserEntity from '@/entity/User';
import { get1on1Name } from '@/modules/1on1s/utils';
import { DEFAULT_FEEDBACK_TAB } from '@/modules/corporate/modules/feedback/views/FeedbackWall/consts';
import { TaskDetailsFragment } from '@/modules/tasks/views/TasksDashboard/graphql/queries/generated/taskDetails';
import routes from '@/pages/corporate/routes';
import { MeetingTypeEnum, TaskAvailableOnEnum } from '@/types/schema';

import { LinkedEntityReturnType } from './types';

const ENTITY_TYPENAME_TASK_AVAILABLE_ON_MAP: Record<MeetingTypeEnum, TaskAvailableOnEnum> = {
  [MeetingTypeEnum.Team]: TaskAvailableOnEnum.Meeting,
  [MeetingTypeEnum.OneOnOne]: TaskAvailableOnEnum.Meeting,
};

export const getTaskLinkedToInfo = (
  t: TFunction,
  entities: TaskDetailsFragment['linkedToEntities'],
) => {
  return (entities || [])
    .map((entity) => {
      switch (entity.__typename) {
        case 'PeerFeedbackSchema': {
          return {
            id: entity.id,
            name: t('Feedback:FeedbackWall.FeedbackTitle', {
              createdBy: entity.senderUser ? UserEntity.firstName(entity.senderUser) : '',
              receiverUser: entity.receiverUser ? UserEntity.firstName(entity.receiverUser) : '',
            }),
            Icon: LargeFeedback,
            label: t('Feedback:FeedbackWall.FeedbackWall'),
            to: routes.Feedback(DEFAULT_FEEDBACK_TAB),
            type: TaskAvailableOnEnum.PeerFeedback,
          };
        }
        case 'MeetingType': {
          if (entity.meetingType === MeetingTypeEnum.Team) {
            return {
              id: entity.id,
              name: entity.meetingName,
              Icon: MeetingOutline,
              label: 'Meeting',
              to: routes.teamMeetingDetails(entity.id),
              type: ENTITY_TYPENAME_TASK_AVAILABLE_ON_MAP[entity.meetingType],
            };
          }

          return {
            id: entity.id,
            name: get1on1Name(entity.participants),
            Icon: MessageSquare2Outline,
            label: '1:1',
            to: routes.oneOnOneDetail(entity.id),
            type: ENTITY_TYPENAME_TASK_AVAILABLE_ON_MAP[entity.meetingType],
          };
        }
      }
    })
    .filter(Boolean) as LinkedEntityReturnType[];
};
